const NAMESPACE = "bulkUpgrade";

const KEYS = {
    smartTemplateMessage: "smartTemplateMessage",
    analyzeButtonLabel: "analyzeButtonLabel",
    upgradeButtonLabel: "upgradeButtonLabel",
    brokenTagMessage: "brokenTagMessage",
    documentTemplateBrokenTagMessage: "documentTemplateBrokenTagMessage",
    communicationTemplateBrokenTagMessage: "communicationTemplateBrokenTagMessage",
    hideLabel: "hideLabel",
    moreInfoLabel: "moreInfoLabel",
    smartTemplateTitle: "smartTemplateTitle"
};

const MESSAGES = {
    [KEYS.smartTemplateMessage]: {
        value: "PowerClerk has made it easier for Program Designers to track which fields and groups are being referenced via template tags in Document Templates and Communication Templates. To take advantage of this feature, you will need to upgrade your existing templates to Smart Templates. This will not result in any behavioral changes when the templates are used.",
        comment: "Message to user about the Smart Template feature"
    },
    [KEYS.analyzeButtonLabel]: {
        value: "Analyze All Templates",
        comment: "Button label to analyze existing templates"
    },
    [KEYS.upgradeButtonLabel]: {
        value: "Upgrade All Templates",
        comment: "Button to upgrade existing templates"
    },
    [KEYS.brokenTagMessage]: {
        value: "During the upgrade process, PowerClerk may identify a tag as broken if it contains a typographical error, if it attempts to reference a field that cannot be found, or if the field has been archived.",
        comment: "Info to user about what consitutes a broken tag"
    },
    [KEYS.documentTemplateBrokenTagMessage]: {
        value: "In order to upgrade a Document Template that contains broken tags, you will need to download the current version of the template, manually remove or correct any broken tags, and upload the corrected version of the template. When you upload the new, error-free version, the template will automatically be upgraded to a Smart Template.",
        comment: "Info to user about what to do when a broken tag is found in a document template"
    },
    [KEYS.communicationTemplateBrokenTagMessage]: {
        value: "In order to upgrade a Communication Template that contains broken tags, you will need to edit the template, manually remove or correct any broken tags, and save the corrected version of the template. When you edit and save any un-upgraded template, it will automatically be upgraded to a Smart Template.",
        comment: "Info to user about what to do when a broken tag is found in a communication template"
    },
    [KEYS.hideLabel]: {
        value: "Hide",
        comment: "Label for button to hide info"
    },
    [KEYS.moreInfoLabel]: {
        value: "More Info",
        comment: "Label for button to show more info"
    },
    [KEYS.smartTemplateTitle]: {
        value: "Smart Templates Available",
        comment: "Title for the Smart Templates info screen"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
